import api from "../services/api";
import { toast } from "sonner";

/**
 * Authenticated download for the invoice PDF endpoint. Streams the response
 * as a blob so the JWT in the Authorization header reaches the server (a
 * plain <a href> would skip it). Triggers a browser download with the
 * `PickNGo-Invoice-<tracking>.pdf` filename.
 */
export async function downloadInvoice(trackingId) {
  if (!trackingId) return;
  try {
    const res = await api.get(`/invoice/${trackingId}`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = `PickNGo-Invoice-${trackingId}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    const status = err.response?.status;
    if (status === 401) toast.error("Please log in to download invoice");
    else if (status === 403) toast.error("Not authorized to view this invoice");
    else if (status === 404) toast.error("Order not found");
    else toast.error("Failed to download invoice");
  }
}
